import { Component, OnInit, AfterViewInit, HostListener, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DebugService } from '../../services/debug.service';
import { DataIoService } from '../../services/data-io.service';
import { TranslationService } from '../../services/translation.service';
import { MenuService } from '../../services/menu.service';
import { ConfigService } from '../../services/config.service';
import { environment } from '../../../environments/environment'
import { MenuNode } from '../../classes/MenuNode';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
    selector: 'app-simulator',
    templateUrl: './simulator.component.html',
    styleUrls: ['./simulator.component.scss']
})
export class SimulatorComponent implements OnInit,AfterViewInit {
	infoText: string;
    _debug : boolean = false;

    _upLoop : any;
    _downLoop : any;
    _loop_interval = 100;
    _loop_offset = 250;
    _timesetEnabled : boolean = true;

    debug(msg:string):void{
        if(this._debug){
            console.log("SimulatorComponent: "+msg);
        }
    }

    getTranslator():TranslationService{
        return this.translator;
    }

    constructor(
        private router : Router,
        private route : ActivatedRoute,
        private debugService: DebugService, 
        private ioService: DataIoService,
        private menuService:MenuService,
        private translator:TranslationService,
        private deviceService: DeviceDetectorService,
        private ref: ChangeDetectorRef,
        private config:ConfigService) { 
        this.debug("Constructor.");
        this._debug = (!environment.production);
    }

    
    @ViewChild("simulatorWrap",{static:true}) simulatorWrap: ElementRef;
    get fontSize(){
        let bigWidth = 570;
        let elWidth = this.simulatorWrap.nativeElement.offsetWidth;
        //console.log("ElWidth:"+elWidth);
        this.ioService.setWindowWidth(elWidth);
        //42.5 bei 360 müsste 39.5 sein
        return 100.0*(elWidth/bigWidth)+"%";
    }
    onResize(event){
        this.ref.markForCheck();

        this.ioService.setWindowWidth(this.simulatorWrap.nativeElement.offsetWidth);
        this.ioService.inputs.resized();
    }
    getWidth(){
        var el = this.simulatorWrap.nativeElement;
        var divWidth = el.offsetWidth
    }
    get opacity(){
        return this.ioService.deviceInfo().getScale('brightness').getCurrentValue()*100;
    }
    ngOnInit() {
        this._timesetEnabled = (!this.ioService.getConfiguration().simulatorConfig.hasControl());
        this.ioService.onInfoTextAvailable().subscribe(
            (element)=>{
                this.showInfoTextFor(element);
            },
            (error)=>{
                this.debug("Error handling focused element: "+JSON.stringify(error));
            }

            );
    }


    ngAfterViewInit(){
        this.getWidth();
    }

    _caption : string = "";
    formatInfoText(str:string):string{
        if(str){
            return str.replace(/\n-/g,"\n\n-");
        }else{
            return '';
        }
    }
    removeVars(title:string):string{
        let matches= title.match(/{{[^t^r^:][^{^}]*?}}/g);
        if(matches != null && matches.length > 0){
            for(let match of matches){
                title = title.replace(match,'');
            }
        }
        return title;
    }
    extractInfoTitle(element:MenuNode){
        let id = element.getIdentifier();

        if(element.isDescendantOf('chimneysweepmodemenu')){
            return this.translator.tr('DELIGHT_MAIN_MENU_ENTRY_CHIMNEY_SWEEPER');
        }
        if(['ecoMode','fachhandwerker-codeabfrage'].includes(id)){
            return element.getTitle();
        }
        if('basic.timeset' == id){
            let title = element.getTitle();
            return title.split(' ').map( (word)=>{
                let fc = word.charAt(0).toUpperCase();
                let rest = word.substr(1,word.length-1);
                return fc+rest.toLowerCase();
            }).join(' ');
        }
        if(id.startsWith('diagnoseCode')){
            return element.getTitle().split('|')[0].replace('D.','d.');
        }
        if(id.startsWith('pruefprogramm_')){
            return element.getSubTitle();
        }

        if(this.menuService.getCurrentNode().getTemplate() == 'inlinemenu' && element.hasChild()){
            return element.getChildByIndex(0).getTitle();
        }
        let rawTitle = element.title;
        // find elements like {{tr:string}}
        let matches= rawTitle.match(/{{tr[^{^}]*?}}/g);
        if(matches != null && matches.length > 0){
            rawTitle = matches[0];
        }
        if(rawTitle == '{{self.value}}'){
            rawTitle = element.defaultValue;
        }
        rawTitle = this.removeVars(rawTitle);
        rawTitle = rawTitle.replace('{{tr:','');
        rawTitle = rawTitle.replace('}}','');
        return rawTitle;
    }

    showDebugInfo:boolean=false;

    infoTextElement : MenuNode;

    showInfoTextFor(element:MenuNode){
        this.infoTextElement = element;
        let infoId = element.getInfoTextId();
        if(element.isDescendantOf('chimneysweepmodemenu')){
            this.infoText = element.getInfoText();
            this._caption = this.extractInfoTitle(element);
            return;
        }
        
        if(infoId != ""){
            this.infoText = this.formatInfoText(this.translator.getInfoText(infoId));
        }else{
            console.log("No Info-Id for "+element.getIdentifier());
            if(element.hasInfoText()){
                console.log("showing infortext for "+element.getIdentifier());
                this.infoText = element.getInfoText();
            }else{
                console.log("No InfoText either");
                this.infoText = "";
            }
        }

        this._caption = this.extractInfoTitle(element);
        
        if(this.showDebugInfo){
            let debugMap = element.toDebugMap();
            this._caption+= "Id: "+element.getIdentifier();
            this.infoText+= "Info: "+"\n"+JSON.stringify(debugMap,null,3);
        }
        
    }

    get caption():string{
        let caption = this.translator.tr(this._caption).replace(':','');
        caption = caption.replace('{{iconControl}} ','');
        caption = caption.replace('{{iconInformation}} ','');
        caption = caption.replace('{{iconConfigurationSettings}} ','');

        let matches = caption.match(/{{getzone\.[0-9]\.name*?/g);
        if(matches){
            matches = caption.match(/[0-9]/);
            if(matches){
                let id= parseInt(matches[0]);
                caption = this.translator.tr('ANCHOR_ZONE_X') + " " + id;
            }else{
                caption = '';
            }
        }

        if(matches){
            matches = caption.match(/[0-9]/);
            if(matches){
                let id= parseInt(matches[0]);
                caption = this.translator.tr('ANCHOR_ZONE_X') + " " + id;
            }else{
                caption = '';
            }
        }
        caption = caption.replace(/[0-9]\/[0-9]*/g,'');

        return caption;
    }

    goToSetup($event){
        $event.preventDefault();
        this.menuService.reset();
        this.router.navigate(['setup']);
    }

    buttonBlinking(btn){
        return this.menuService.buttonBlinking(btn);
    }


    buttonMuted(btn){
        return this.menuService.buttonMuted(btn)|| this.menuService.isDisabledByView(btn);
    }

    powerClicked(){
        
        if(this._powerDisabledOnce){
             this._powerDisabledOnce = false;
             return;
        }

        if(this.menuService.getCurrentNode().getTemplate() == 'control-showcase'){
            this.ioService.powerClicked();
            return;
        }
        
        console.log("Powerbutton clicked at state "+this.ioService.getDeviceInfo().getValue('powerstate'));
        if(this.ioService.getDeviceInfo().getValue('powerstate') == 'off'){
            this.menuService.goto('idle');
            this.ioService.getDeviceInfo().setValue('powerstate','on');
            return;
        }

        if(this.ioService.getDeviceInfo().getValue('powerstate') == 'on'){
            this.ioService.getDeviceInfo().setValue('powerstate','going-to-standby');
            this.menuService.goto('off');
            setTimeout(()=>{
                this.ioService.getDeviceInfo().setValue('powerstate','off');
                this.menuService.goto('idle');
            },2000);
            return;
        }
    }

    toggleSchedule(){
        console.log("Toggling schedule.");
        let di = this.ioService.getDeviceInfo();
        if(di.getValue('heizmodus') == 'Zeitgesteuert'){
            di.setValue('heizmodus','Manuell');
            this.ioService.deviceInfo().tempFrame = null;
            this.menuService.goto('disableZeitprogramm');
        }else{
            di.setValue('heizmodus','Zeitgesteuert');
            this.menuService.goto('enableZeitprogramm');
        }
        
    }

    _timerDownTimer:any=undefined;
    startToggleTimer(){
        this.stopToggleTimer();
        this._timerDownTimer = setTimeout( ()=>{
            this.toggleSchedule();
        },2000);
    }
    stopToggleTimer(){
        if(this._timerDownTimer){
            clearTimeout(this._timerDownTimer);
            this._timerDownTimer = undefined;
        }
    }
    
    timerDown(){
        this.startToggleTimer();
    }

    timerUp(){        
        this.stopToggleTimer();
    }

    timerClicked(){
        this.stopToggleTimer();
        this._timerDownTimer = undefined;
        if( this.buttonMuted('timer') ){
            return false;
        }
        //this.ioService.inputs.timerClicked();
        this.menuService.goto('basic_zeitprogramm');
    }

    whiteTimer(){
        return false;
    }
    whiteQuestionMark():boolean{
        let nodeId = this.menuService.getCurrentNode().getIdentifier();
        switch(nodeId){
            case 'wizard_help':{
                return true;
            }
            default:{
                return false;
            }
        }
        return false;
    }
    whiteMenuButton() : boolean{
        let nodeId = this.menuService.getCurrentNode().getIdentifier();
        if(nodeId == 'fachhandwerkerebene' || this.menuService.getCurrentNode().isDescendantOf('fachhandwerkerebene')){
            console.log("White menu button: false. descendant of fhe");
            return false;
        }

        if(nodeId)
            switch(nodeId){
                case 'dashboard':
                case 'basic_zeitprogramm':
                case 'idle':
                case 'benutzerhandbuch':
                case 'benutzerhandbuch_plain':{
                    return false;
                }
                default:{
                    if(nodeId.startsWith('controlshowcase')||nodeId.startsWith('wizard-controlshowcase')){
                        return false;
                    }
                }
            }
            return true;
        }
        hasNotButton(btn){
            return (!!!this.hasButton(btn));
        }

        hasButton(btn){
            if(!this._timesetEnabled && btn == 'timer'){
                return;
            }
            if(btn == 'power'){
                return true;
            }
            let di = this.ioService.getDeviceInfo();
            if(di.getValue('powerstate') == 'off'){
                return false;
            }
            if(di.getValue('powerstate') == 'off' && btn != 'menu'){
                return false;
            }
            if(btn == "scrollbar"){

            }
            if(btn == 'question'){
                return this.menuService.helpAvailable() || this.menuService.buttonEnabled('question');
            }

            if(this.menuService.isDisabledByView(btn)){
                return false;
            }
            
            if(['chimney','timer','dhw','heating'].includes(btn)){
                if( this.menuService.getCurrentNode().getIdentifier() == 'dashboard' ){
                    return true;
                }
            }
            return this.menuService.buttonEnabled(btn);
        }

        whiteHeatingButton(){
            return (!this.buttonMuted('heating') && this.ioService.deviceInfo().getRawValue('ai_mode')=='heating');
        }
        whiteDHWButton(){
            return (!this.buttonMuted('dhw') && this.ioService.deviceInfo().getRawValue('ai_mode')=='dhw');
        }
        questionClicked(){
            this.ioService.questionClicked();
        }
        backClicked(){
            if(!this.buttonMuted('back')){
                this.ioService.backClicked();
            }
        }
        chimneyClicked(){

            if(this.buttonMuted('chimney')){
                return;
            }
            this.ioService.chimneyClicked();
            if(this.menuService.getCurrentNode().getTemplate() != 'control-showcase'){
                this.menuService.goto('chimneysweep');
            }

        }
        dhwClicked(){
            if(this._dhwDisabledOnce){
                this._dhwDisabledOnce = false;
                return;
            }
            if(this.buttonMuted('dhw')){
                return;
            }
            this.ioService.deviceInfo().setValue('ai_mode','dhw');
            this.ioService.dhwClicked();
        }
        heatingClicked(){
            if(this._heatingDisabledOnce){
                this._heatingDisabledOnce = false;
                return;
            }
            console.log("heating clicked.");
            if(this.buttonMuted('heating')){
                return;
            }
            this.ioService.deviceInfo().setValue('ai_mode','heating');
            this.ioService.heatingClicked();
        }

        confirmClicked(){
            if(!this.buttonMuted('confirm')){
                this.ioService.confirmClicked();
            }else{
                this.debug("Confirm muted.");
            }
        }
        isLocked(){
            return this.ioService.getDeviceInfo().getValue('buttonlock') == 'on';
        }
        unlockSequence = false;
        _dhwToggleTimeout:any = null;
        _heatingToggleTimeout:any = null;
        _restartTimeout:any = null;
        _dhwDisabledOnce:boolean = false;
        _heatingDisabledOnce:boolean = false;
        _powerDisabledOnce:boolean = false;
        triggerRestart(){
            console.log("toggle on dhw.");
            this._powerDisabledOnce = true;
            this._restartTimeout = null;
            this.menuService.goto('restart');
        }
        toggleDHW(){
            console.log("toggle on dhw.");
            this._dhwDisabledOnce = true;
            this._dhwToggleTimeout = null;
            let currentMode = this.ioService.deviceInfo().getRawValue('ai_mode_dhw');
            this.ioService.deviceInfo().setValue('ai_mode_dhw',currentMode=='OFF'?'ON':'OFF');
            let s = this.ioService.deviceInfo().getScale('d006');
            if(currentMode === 'OFF'){
                s.restoreValue();
            }else{
                s.saveValue();
                s.setCurrentValue(29);
            }
            this.menuService.goto(currentMode=='OFF'?'enableAIDHW':'disableAIDHW');
        }

        toggleHeating(){
            console.log("toggle on heating.");
            this._heatingDisabledOnce = true;
            this._heatingToggleTimeout = null;
            let currentMode = this.ioService.deviceInfo().getRawValue('ai_mode_heating');
            this.ioService.deviceInfo().setValue('ai_mode_heating',currentMode=='OFF'?'ON':'OFF');
            this.menuService.goto(currentMode=='OFF'?'enableAIHeating':'disableAIHeating');
            let s = this.ioService.deviceInfo().getHeatingCircuitById(1).getScale('vorlaufsolltemp');
            if(currentMode === 'OFF'){
                s.restoreValue();
            }else{
                s.saveValue();
                s.setCurrentValue(29);
            }

        }
        aiMode(){
            if(this.menuService.getCurrentNode().getIdentifier() != 'dashboard'){
                return '';
            }
            if(this.ioService.deviceInfo().getRawValue('ai_mode') == 'heating'){
                return 'heating';
            }
            if(this.ioService.deviceInfo().getRawValue('ai_mode') == 'dhw'){
                return 'dhw';
            }
            return '';
        }
        buttonDown(btn){
            if(btn == 'power'){
                
                if(this._restartTimeout){
                    clearTimeout(this._restartTimeout);
                }
                this._restartTimeout = setTimeout(
                    ()=>{this.triggerRestart();},
                    3000
                );
                return;
            }
            if(btn == 'dhw'){
                if(this.aiMode() != 'dhw'){
                    console.log("not in dhw-mode. aborting.");
                    return;
                }
                if(this._dhwToggleTimeout){
                    clearTimeout(this._dhwToggleTimeout);
                }
                this._dhwToggleTimeout = setTimeout(
                    ()=>{this.toggleDHW();},
                    3000
                );
                return;
            }
            if(btn == 'heating'){
                if(this.aiMode() != 'heating'){
                    return;
                }
                console.log("heating down.");
                if(this._heatingToggleTimeout){
                    clearTimeout(this._heatingToggleTimeout);
                }
                this._heatingToggleTimeout = setTimeout(
                    ()=>{this.toggleHeating();},
                    3000
                );
                return;
            }
            if(btn === 'menu' && this.isLocked()){
                this.unlockSequence = true;
                this.menuService.goto('unlocksequence');
            }
        }
        buttonUp(btn){
            if(btn === 'menu' && this.isLocked()){
                console.log("going to idle.");
                this.menuService.goto('idle');
            }

            if(btn == 'power' && this._restartTimeout != null){
                clearTimeout(this._restartTimeout);
                this._restartTimeout = null;
                return;
            }
            if(btn == 'heating' && this._heatingToggleTimeout != null){
                console.log("heating up.");
                clearTimeout(this._heatingToggleTimeout);
                this._heatingToggleTimeout = null;
                return;
            }
            if(btn == 'dhw' && this._dhwToggleTimeout != null){
                clearTimeout(this._dhwToggleTimeout);
                this._dhwToggleTimeout = null;
                return;
            }
       }
        menuClicked(){
            if(this.isLocked()){
                return;
            }
            if(this.unlockSequence){
                this.unlockSequence = false;
                return;
            }
            if(!this.buttonMuted('menu')){
                if(this.hasButton('menu')){
                    this.ioService.menuClicked();
                }
            }
        }


        menuUpClicked(){
            if(this.buttonMuted('up')){
                return;
            }
            this.debug("UpClicked");
            if(this.clickEnabled){
                this.ioService.upClicked();
            }
            
        }



        menuDownClicked(){
            if(this.buttonMuted('down')){
                return;
            }
            this.debug("DownClicked");
            if(this.clickEnabled){
                this.ioService.downClicked();
            }
            

        }


        onPan($event){
            
            this._downPressed=false;
            this._upPressed=false;
        }

        _panning = false;


        onPanStart($event){
            this._panning=true;
            this.ioService.panStart();
            this._downPressed=false;
            this._upPressed=false;
        }

        clickEnabled = true;
        disableClick(){
            this.clickEnabled = false;
        }
        enableClick(){
            this.clickEnabled = true;
        }
        onPanEnd($event){
            $event.preventDefault();
            setTimeout(()=>{
                this.enableClick();
            },50);
            this._panning = false;
            this.ioService.panEnd();
            this._downPressed=false;
            this._upPressed=false;
        }


        onPanMove($event){

        }


        onPanUp($event){
            $event.preventDefault();
            this.disableClick();
            this._downPressed = false;
            this._upPressed = false;
            
            if(this.buttonMuted('up')&&this.buttonMuted('slider')){
                return;
            }
            if(this._panning){
                this.ioService.panUp();
            }

        }


        pans=0;
        skips=6;


        onPanDown($event){
            this.disableClick();
            this._downPressed = false;
            
            this._upPressed = false;
            if(this.buttonMuted('down')&&this.buttonMuted('slider')){
                return;
            }
            
            //this.pans = (++this.pans % this.skips);
            if(this._panning){
                this.ioService.panDown();
            }

        }

        downPressed($event){
            
            $event.preventDefault();
            this._upPressed = false;
            this._downPressed = true;
            setTimeout(
                ()=>{
                    if(this._downPressed && !this._panning){
                        this._downLoop = setInterval(
                            ()=>{
                                if(!this._downPressed||this._panning){
                                    clearInterval(this._downLoop);
                                    return;
                                }else{

                                    this.menuDownClicked();
                                }
                            },
                            this._loop_interval);
                    }
                },
                this._loop_offset);
        }


        downReleased($event){
            this._downPressed = false;
            this._upPressed = false;
        }


        upPressed($event){
            
            $event.preventDefault();
            this._downPressed = false;
            this._upPressed = true;
            setTimeout(
                ()=>{
                    if(this._upPressed && !this._panning){
                        this._upLoop = setInterval(
                            ()=>{
                                if(!this._upPressed||    this._panning){
                                    clearInterval(this._upLoop);
                                    return;
                                }else{

                                    this.menuUpClicked();
                                }
                            },
                            this._loop_interval);
                    }
                },
                this._loop_offset);
        }


        upReleased($event){
            //console.log("Up released.");
            this._upPressed = false;
            this._downPressed = false;
        }
        _downPressed=false;
        _upPressed=false;
        
        @HostListener('window:keydown', ['$event'])
        keyEvent(ke: KeyboardEvent) {
            switch(ke.keyCode){
                case 68:{//d
                    ke.stopPropagation();
                    let fhwe = this.menuService.getCurrentNode().findFromRoot('fachhandwerkerebene');
                    for(let child of fhwe.getChilds()){
                        child.selected = "false";
                        if(child.getTitle() == "d"){
                            child.selected = "true";
                        }
                    }
                    this.menuService.goto('diagnoseCodeMenu');

                    return false;
                }
                case 67:{
                    ke.stopPropagation();
                    this.menuService.goto('chimneysweepmodemenu');
                    return false;
                }
                case 70:{ // f;
                    ke.stopPropagation();
                    this.menuService.goto('fachhandwerkerebene');
                    return false;
                }
                case 80:{ // p;
                    ke.stopPropagation();
                    this.menuService.goto('basic_pruefprogramme');
                    return false;
                }
                case 84:{ // t  - toggle debuǵ
                    console.log("Toggling debug.");
                    ke.stopPropagation();
                    this.showDebugInfo = ! this.showDebugInfo;
                    this.showInfoTextFor(this.infoTextElement);
                    return false;
                }
                case 13:{
                    this.confirmClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 37:{
                    this.backClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 38:{
                    this.menuUpClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 39:{
                    this.menuClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
                case 40:{
                    this.menuDownClicked();
                    ke.stopPropagation();
                    ke.stopImmediatePropagation();
                    return false;
                }
            }
            console.log("Key Pressed: "+ke.keyCode);
            this.debug("Key Down: "+ke.keyCode);
        }



    }